export default "__VITE_ASSET__DbtuwQA8__"